import { route } from '../helpers';

import { OtherPages } from '../../constants/AppConstants';

export default route(OtherPages.PAYMENT_LANDING, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/other/PaymentLanding').default);
        }, 'order-payment');
    }
});
